module.exports = __webpack_public_path__ + "faq/img/evaluate_1.5998e86a.png";